import {useEffect, useState, useCallback} from 'react'
import {DrawerComponent} from '../_metronic/assets/ts/components'

export const useMetronicAsideHover = () => {
  const [isHovered, setIsHovered] = useState(false)

  useEffect(() => {
    const aside = document.getElementById('kt_aside')
    if (!aside) return

    const handleEnter = () => setIsHovered(true)
    const handleLeave = () => setIsHovered(false)

    aside.addEventListener('mouseenter', handleEnter)
    aside.addEventListener('mouseleave', handleLeave)

    return () => {
      aside.removeEventListener('mouseenter', handleEnter)
      aside.removeEventListener('mouseleave', handleLeave)
    }
  }, [])

  return isHovered
}
